import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ErrCode, ErrorMessages, User } from '../../models';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorComponent {
  public _errCode:ErrCode;
  @Input() overrideErrorMsgWithServer : boolean = false;

  @Input() set errcode(errcode: ErrCode) {
    this._errCode = {...errcode};
    if (errcode && errcode.code) {
        // Error message should always pick from error code mapping in error-messages.model.ts.
        // When error message not found in error-messages.model.ts, Then it will by default pick errorcode.msg or 'An error occurred.'
        if (ErrorMessages[errcode.code]) {
          if(!this.overrideErrorMsgWithServer){
             this._errCode.msg = ErrorMessages[errcode.code];
          }
        }
    }
  }

  @Input() showErrCode? : boolean = true;

  public user: User;

  // get errcode(): ErrCode {
  //   return this._errCode;
  // }
  
  constructor(
    private sanitizer: DomSanitizer,  
  ){ }
}
